/* eslint-disable @typescript-eslint/ban-types -- TODO: Clean code !!! */
/* eslint-disable @typescript-eslint/no-explicit-any -- TODO: Clean code !!! */
import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./dynamic-forms.html?ngResource";
import _ from 'lodash';
import { Component, Input, Output, EventEmitter, ChangeDetectorRef, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormioModule, registerCustomFormioComponent } from '@formio/angular';
import { DynamicFormsService } from './dynamic-forms.service';
import { TimezoneSelectorComponent } from '../timezone/timezone-selector.component';
let DynamicFormsComponent = class DynamicFormsComponent {
    formsService;
    cdr;
    injector;
    model;
    id;
    options = {};
    notifyChange;
    schema;
    evalContext;
    modelChange = new EventEmitter();
    builderChange = new EventEmitter();
    feedback = new EventEmitter();
    formReady = new EventEmitter();
    formio;
    form;
    submission = { data: {} };
    builder;
    refreshForm = new EventEmitter();
    formTitle = '';
    enableBuilder = false;
    showBuilder = false;
    showAdvanced = false;
    readOnly = false;
    defaultForm;
    _formBackup;
    formRendererOptions = {
        evalContext: {}
    };
    constructor(formsService, cdr, injector) {
        this.formsService = formsService;
        this.cdr = cdr;
        this.injector = injector;
        if (!customElements.get('select-timezone')) {
            registerCustomFormioComponent({
                type: 'select-timezone',
                selector: 'select-timezone',
                title: 'Select Timezone',
                group: 'basic',
                icon: 'clock',
                changeEvent: 'timezoneChange',
            }, TimezoneSelectorComponent, injector);
        }
    }
    async ngOnInit() {
        if (this.notifyChange) {
            this.notifyChange.subscribe((event) => {
                this.onNotifyChange(event);
            });
        }
        await this.generateFormInfo();
        this.builder = {
            builder: {
                premium: false,
                layout: false,
                advanced: { components: { signature: false } },
                data: {
                    components: {
                        datamap: false,
                        datagrid: false,
                        editgrid: false,
                        tree: false
                    }
                },
            },
            noDefaultSubmitButton: true
        };
    }
    async generateFormInfo() {
        this.enableBuilder = Boolean(this.options.enableBuilder);
        this.showBuilder = Boolean(this.options.showBuilder);
        this.readOnly = Boolean(this.options.readOnly);
        this.formTitle = this.options.title;
        _.set(this.submission, 'metadata', { id: this.id });
        this.formRendererOptions.evalContext = this.evalContext || {};
        let newForm = this.options.buildFromSchema ? this.schema : this._formBackup;
        if (!newForm) {
            newForm = await this.formsService.generateForm(this.options);
            if (!this.options?.doNotExtendFormWithModel) {
                newForm = await this.formsService.extendFormWithModel(newForm, this.model);
            }
        }
        if (_.isEmpty(this.model)) {
            this.showAdvanced = this.showAdvanced || _.isEmpty(newForm.components);
        }
        if (this.showAdvanced && !this.options.hideAdvanced) {
            _.set(this.submission, 'data', { model: this.model });
            newForm = await this.formsService.getForm('rawjson');
        }
        else {
            _.set(this.submission, 'data', this.model);
        }
        // only set the form if it's a different form, to reduce unneeded form redraws
        // using _.isMatch here since the 'form' we generate is a 'slim' version w/o default values
        if (!_.isMatchWith(this.form, newForm, (objVal, srcVal) => {
            if (_.isArray(objVal) && _.isArray(srcVal) && objVal.length !== srcVal.length) {
                return false;
            }
        })) {
            this.form = newForm;
        }
        this.cdr.detectChanges();
    }
    destroyForm() {
        if (this.formio?.destroy) {
            this.formio.resetValue();
            this.formio.destroy();
        }
    }
    onReady({ formio }) {
        this.formio = formio;
        this.formReady.emit({ formio });
    }
    onFormDataChange(event) {
        const fromSubmission = _.get(event, ['changed', 'flags', 'fromSubmission'], false);
        if (event.changed && !fromSubmission && event.isValid) {
            const id = event?.metadata?.id;
            const eventIsRaw = _.keys(event.data).length === 1 &&
                event.data.model; // Allows `model` property to share namespace
            const model = eventIsRaw
                ? event.data.model
                : this.formsService.stripNonPersistentFields(event.data, this.form?.components);
            // TODO: I was reverted in a hotfix. Fix me later!
            this.model = model;
            this.modelChange.emit({ id, model: this.model });
        }
        if (this.formio) {
            this.feedback.emit({
                type: 'isValid',
                // there are cases where the 'event.isValid' is incorrect, namely with a new/pristine form with required fields
                // so we'll force a validity check here and emit the result
                data: this.formio.checkValidity(null, !this.formio.pristine)
            });
        }
    }
    onFormBuilderChange(event) {
        if (_.includes(['addComponent', 'saveComponent', 'deleteComponent'], event.type)) {
            this._formBackup = event.form;
            this.builderChange.emit(event.form);
        }
    }
    async toggleAdvanced() {
        this.showAdvanced = !this.showAdvanced;
        await this.generateFormInfo();
    }
    toggleEditForm() {
        this.showBuilder = !this.showBuilder;
    }
    async onNotifyChange(event) {
        if (event.model) {
            // Merge the incoming model with current formio data to preserve user's form changes
            // that weren't emitted due to form being invalid (e.g., when required fields are empty).
            // This prevents external events (like map clicks) from reverting user's changes.
            const currentFormData = this.formio?.getValue?.()?.data;
            this.model = currentFormData ? { ...currentFormData, ...event.model } : event.model;
            await this.generateFormInfo();
            this.refreshForm.emit({
                submission: this.submission
            });
        }
    }
    onCustomEvent(event) {
        if (this.formsService.handleEvent(event, this.form)) {
            this.refreshForm.emit({
                form: this.form
            });
        }
    }
    async ngOnChanges(changes) {
        const { model, options, schema, id, evalContext } = changes;
        if ([
            model?.firstChange,
            options?.firstChange,
            schema?.firstChange,
            id?.firstChange,
            evalContext?.firstChange
        ].includes(false)) {
            this._formBackup = null;
            this.showAdvanced = false;
            await this.generateFormInfo();
            this.refreshForm.emit({
                submission: this.submission
            });
        }
    }
    static ctorParameters = () => [
        { type: DynamicFormsService },
        { type: ChangeDetectorRef },
        { type: Injector }
    ];
    static propDecorators = {
        model: [{ type: Input }],
        id: [{ type: Input }],
        options: [{ type: Input }],
        notifyChange: [{ type: Input }],
        schema: [{ type: Input }],
        evalContext: [{ type: Input }],
        modelChange: [{ type: Output }],
        builderChange: [{ type: Output }],
        feedback: [{ type: Output }],
        formReady: [{ type: Output }]
    };
};
DynamicFormsComponent = __decorate([
    Component({
        selector: 'dynamic-forms',
        standalone: true,
        imports: [
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            FormioModule
        ],
        template: __NG_CLI_RESOURCE__0
    })
], DynamicFormsComponent);
export { DynamicFormsComponent };
